import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    faqItem: {
        borderRadius: '20px',
        border: '1px solid rgba(119, 183, 255, 0.25)',
        backgroundColor: '#fff',
        marginBottom: '20px',
        '&:last-child': {
            marginBottom: '0',
        },
        '& .faq-item-header': {
            padding: '20px',
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'pointer',
            alignItems: 'center',
            '& img': {
                maxWidth: '20px',
                '@media screen and (max-width: 480px)': {        
                    maxWidth: '15px',
                    marginLeft: '10px',
                },
            },
            '& h3': {
                marginBottom: '0',
                fontSize: '22px',
                '@media screen and (max-width: 768px)': {
                    fontSize: '18px',
                },
                '@media screen and (max-width: 480px)': {
                    fontSize: '16px',
                    fontWeight: '500',
                }
            },
            '@media screen and (max-width: 480px)': {
                padding: '15px',
            }
        },
        '& .faq-item-body': {
            borderTop: '1px solid rgba(119, 183, 255, 0.25)',
            backgroundColor: '#f6fcff',
            borderBottomLeftRadius: '20px',
            borderBottomRightRadius: '20px',
            '& p': {
                marginBottom: 0,
            },
        },
        '& .faq-item-content': {
            padding: '20px',
            '& p': {
                '@media screen and (max-width: 480px)': {
                    fontSize: '14px',
                },
            }
        },
        '@media screen and (max-width: 480px)': {
            borderRadius: '15px',
        }
    },
})

function FAQItem(props) {

    var classes = useStyles()

    const [isActive, setActive] = useState(false);

    const toggleClass = () => {
        setActive(!isActive);
    };

    useEffect(
        () => {
            document.getElementById("faqContent" + props.id).innerHTML = "<p>" + props.content + "</p>";
        }
    , [props.id, props.content])

    return (
        <div className={classes.faqItem}>
            <div onClick={toggleClass} className="faq-item-header">
                <h3>{props.question}</h3>
                {/* <img src="img/icons/dropdown.png" alt=""/> */}
            </div>
            <div className={"faq-item-body collapse " + (isActive ? "show" : null)}>
                <div className="faq-item-content" id={"faqContent" + props.id}>
                    <p></p>
                </div>
            </div>
        </div>
    )
}

export default FAQItem
